import { render, staticRenderFns } from "./breadcrumbPage.vue?vue&type=template&id=2bd09e04&scoped=true"
import script from "./breadcrumbPage.vue?vue&type=script&lang=js"
export * from "./breadcrumbPage.vue?vue&type=script&lang=js"
import style0 from "./breadcrumbPage.vue?vue&type=style&index=0&id=2bd09e04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd09e04",
  null
  
)

export default component.exports